import { useRef, useEffect } from "react";
import "./Loading.css";


const Loading = () => {
  const layerDiv: any = useRef(null);
  const outerScroll: any = useRef(null);
  const innerScroll: any = useRef(null);
  const outerLogo: any = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      outerLogo.current?.classList.add("animate");
      layerDiv.current?.classList.add("animate");
      outerScroll.current?.classList.add("animate");
      innerScroll.current?.classList.add("animate");
    }, 10);
  }, []);

  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        minHeight: "100px",
        height: "100%",
        backgroundColor: "#F9F9F9",
        position: "absolute",
        top: 0,
        left: 0,
        zIndex: 1000
      }}
    >
      <div style={{ margin: "auto" }}>
        <div ref={outerLogo} className={"loading-l8"}>
          <div ref={layerDiv} className="anim anim-opacity2 r-center">
            <span style={{ color: "black" }}>LAYER</span>
            <span style={{ color: "red" }}>8</span>
          </div>
          <div
            ref={outerScroll}
            className="anim anim-opacity w-100"
            style={{ backgroundColor: "inherit" }}
          >
            <div ref={innerScroll} className="anim anim-width">
              &nbsp;
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Loading;
